import {CmsAPI} from '../helpers/http-client';
import { CountryCode, RedisKey } from '../constants';
import { getKeyByValue } from '../helpers/common';
import RedisClient from '../../lib/helpers/redis-client';
class BlogService{
    getCategories=async(countryCode:CountryCode)=>{
        try {
            const keyName=RedisKey.CategoryListByCountryCMS;
            const redisResult=await RedisClient.getValue(keyName,countryCode);
            if(redisResult)
                return redisResult;
            const result=await CmsAPI.get("inco-cms/categoryListByCountry?country="+countryCode.toUpperCase());
            if(result && result.status==200)        
            {
                const value =result.data;
                const data = value && value.slice(0,5)?.map((m:any)=>{
                    return{
                        cat_id:m.cat_id,
                        cat_name:m.cat_name,
                        cat_url:m.cat_url,
                        parmalink:m.parmalink,
                        cat_relative:m.cat_relative,
                        post_count:m.post_count
                          }}) || []
                if(data)
                    RedisClient.setValue(keyName,data,countryCode); 
                return data || [];
            }
            else
                return [];   
        } catch (error) {
            console.error(error);
            return [];
        }         
    }

    featuredPostsByCountry=async(countryCode:CountryCode)=>{
        try {
            const keyName=RedisKey.FeaturedPostsByCountryCMS;
            const redisResult=await RedisClient.getValue(keyName,countryCode);
            if(redisResult)
                return redisResult;
            const result=await CmsAPI.get("inco-cms/featuredPostsByCountry?country="+countryCode.toUpperCase());
            if(result && result.status==200) {
                if(result.data){
               const value = result.data.map((a:any,idx:number)=>
                {
                    return {
                            post_title:a.post_title,
                            post_content: idx === 0 ? a.post_content : null,
                            post_published_date:a.post_published_date,
                            post_updated_date:a.post_updated_date,
                            parmalink:a.parmalink,
                            post_relative:a.post_relative,
                            post_cat_name:a.post_cat_name                
                          }
               }
               )
               if(value)
               RedisClient.setValue(keyName,value, countryCode); 
               return value || [];
                }       
            }
            else
                return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
         
    }

    featuredPostsByCategory=async(category:string,countryCode:CountryCode)=>{
        try {
            const result=await CmsAPI.get(`inco-cms/catList?catName=${category}&country=${countryCode.toUpperCase()}`);
            if(result && result.status==200)        
            {
                const value=result.data;
                if(value)
                return value || [];
            }
            else
                return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
         
    }

    featuredPostsByDiCategory=async(category:string,countryCode:CountryCode)=>{
        try {
            const result=await CmsAPI.get(`inco-cms/catList?diSlug=${category}&country=${countryCode.toUpperCase()}`);
            if(result && result.status==200)        
            {
                const value=result.data;
                if(value){
                    return value.map((a:any)=>{
                        return {
                            post_title:a.post_title,
                            parmalink:a.parmalink,
                            post_relative:a.post_relative               
                          }
                    })
                }
                return value || [];
            }
            else
                return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
         
    }
    getPostBySlug=async(postSlug:string ,countryCode:CountryCode)=>{
        try {
            const result=await CmsAPI.get("inco-cms/postdetail?country="+countryCode.toUpperCase()+`&postslug=${postSlug}`);
            if(result && result.status==200){
                if(result.data){
                    const data = result && result.data &&  result.data[0]
                    const value:any = [{
                        post_id:data.post_id,
                        short_paragraph:data.short_paragraph||"",
                        toc:data.toc,
                        post_title:data.post_title,
                        post_content:data.post_content,
                        post_date:data.post_date,
                        post_updated_date:data.post_updated_date,
                        parmalink:data.parmalink,
                        post_relative:data.post_relative,
                        author_name:data.author_name,
                        author_relative:data.author_relative,
                        autho_slug:data.autho_slug,
                        postCount:data.postCount,
                        meta_title:data.meta_title,
                        meta_description:data.meta_description,
                        Post_faq:data.Post_faq,
                        post_category:data.post_category,
                        image_Urls:data.image_Urls,
                        related_post:data?.related_post?.slice(0,5)?.map((f:any)=>{
                            return {
                                post_id:f.post_id,
                                post_title:f.post_title,
                                post_date:f.post_date,
                                post_updated_date:f.post_updated_date,
                                parmalink:f.parmalink,
                                post_relative:f.post_relative
                                   }}) || []
                    
                 }]
                   if(value) return value
                }
            }   
            else
                return [];  
        } catch (error) {
            console.error(error);
            return [];
        }
          
    }

    getTrendList=async(countryCode:CountryCode)=>{
        try {
            const keyName=RedisKey.GetTrendListV1;
            const redisResult=await RedisClient.getValue(keyName,countryCode);
            if(redisResult)
                return redisResult;

            const result=await CmsAPI.get("inco-cms/v1/trendListByCountry?country="+countryCode.toUpperCase());
            if (result && result.status == 200) {
                if (result.data) {
                  const itemCount = 5;
                  const value = result.data.map((d: any) => {
                    let pendingCount = itemCount - d.sub_cat_data.length;
                    return {
                      cat_id: d.cat_id,
                      cat_name: d.cat_name,
                      cat_slug: d.cat_slug,
                      sub_cat_data:(d.sub_cat_data && d.sub_cat_data.map((s: any) => {
                           const posts = s.posts.filter((post: any, index: number) => index == 0 );
                            if (pendingCount > 0) {
                              const restPost = s.posts.filter((post: any, index: number) => index > 0 );
                              posts.push(...restPost.slice(0, pendingCount));
                              pendingCount = pendingCount - restPost.length;
                            } else {
                              return {
                                sub_category_id: s.sub_category_id,
                                sub_cat_slug: s.sub_cat_slug,
                                sub_cat_name: s.sub_cat_name,
                                posts:posts && posts.map((m:any)=>{
                                    return {
                                        post_id:m.post_id,
                                        post_published_date:m.post_published_date,
                                        post_relative:m.post_relative,
                                        post_slug:m.post_slug,
                                        post_title:m.post_title,
                                        post_content:m.post_content.slice(0,200)
                                           }
                                }),
                              }
                            }
                            return {
                              sub_category_id: s.sub_category_id,
                              sub_cat_slug: s.sub_cat_slug,
                              sub_cat_name: s.sub_cat_name,
                              posts:posts && posts.map((m:any)=>{
                                return {
                                    post_id:m.post_id,
                                    post_published_date:m.post_published_date,
                                    post_relative:m.post_relative,
                                    post_slug:m.post_slug,
                                    post_title:m.post_title,
                                    post_content:m.post_content.slice(0,200)
                                       }
                            }),
                            };
                          })) || [],
                    };
                  });
        
                  if (value) RedisClient.setValue(keyName, value, countryCode);
                  return value;
                } 
                else return [];
              }
            else
                return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    getTrendsCategory=async(countryCode:CountryCode,categorySlug:any)=>{
        try {
            const result=await CmsAPI.get("inco-cms/v1/trendListByCountry?country="+countryCode.toUpperCase()+`&parentslug=${categorySlug}`);
            if(result && result.status==200){
                if(result.data){
                const data =  result.data
                const value:any = {
                    cat_id:data.cat_id,
                    cat_name:data.cat_name,
                    cat_slug:data.cat_slug,
                    banner_text_h1:data.banner_text_h1,
                    banner_text_h2:data.banner_text_h2,
                    meta_title:data.meta_title,
                    meta_description:data.meta_description,
                    parent_cat:data.parent_cat,
                    sub_cats:data.sub_cats.map((f:any)=>{
                      return{
                        sub_cat_name:f.sub_cat_name,
                        sub_cat_slug:f.sub_cat_slug,
                        sub_cat_relative:f.sub_cat_relative
                      }}) || [],
                    sub_cat_data:data.sub_cat_data.map((m:any)=>{
                       return {
                         sub_cat_id:m.sub_cat_id,
                         sub_cat_name:m.sub_cat_name,
                         sub_cat_slug:m.sub_cat_slug,
                         posts:m.posts.map((p:any)=>{
                        return {
                            post_id:p.post_id,
                            post_title:p.post_title,
                            post_relative:p.post_relative,
                            post_slug:p.post_slug,
                            sub_cat_name:p.sub_cat_name,
                            sub_cat_slug:p.sub_cat_slug
                       }}) || []
                     }})
                }
                if(value) return value
            }}     
            else
                return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }
   
    getTrendsSubCategory=async(countryCode:CountryCode,subCategorySlug:string,pageNo:number)=>{
        try {
            const pagesize = 10
            const result=await CmsAPI.get("inco-cms/v1/trendListByCountry?country="+countryCode.toUpperCase()+`&cat=${subCategorySlug}`+`&pageno=${pageNo}&pagesize=${pagesize}`);
            if(result && result.status==200) {    
                if(result.data) {
                const data = result.data
                 const value:any = {
                                cat_name:data.cat_name,
                                cat_slug:data.cat_slug,
                                cat_description:data.cat_description,
                                parent_cat_name:data.parent_cat_name,
                                parent_cat_slug:data.parent_cat_slug,
                                paging_data:data.paging_data,
                                meta_title:data.meta_title,
                                banner_text_h1:data.banner_text_h1,
                                meta_description:data.meta_description,
                                top_cats:data?.top_cats.map((f:any)=>{
                                   return {
                                           sub_cat_name:f.sub_cat_name,
                                           sub_cat_slug:f.sub_cat_slug
                                   }}) || [],
                                posts:data?.posts.map((m:any)=>{
                                   return {
                                            post_id:m.post_id,
                                            post_title:m.post_title,
                                            post_content:m.post_content.slice(0,200),
                                            post_relative:m.post_relative,
                                            post_slug:m.post_slug,
                                            author_relative:m.author_relative,
                                            author_name:m.author_name,
                                            author_slug:m.author_slug,
                                            post_published_date:m.post_published_date,
                                            post_updated_date:m.post_updated_date
                                  }}) || []
                               }
                     if(value) return value    
                     else return []      
                }
            }
            else
                return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }
   
    
    getAuthors=async(countryCode:CountryCode,_allAuthorsReq?:Boolean)=>{
        try {
            const result=await CmsAPI.get("inco-cms/author?country="+countryCode.toUpperCase());
            if(result && result.status==200){   
                const data = result.data && result.data.authors
                if(data){
                    const value = (_allAuthorsReq && _allAuthorsReq !=undefined ? data : data.slice(0,6)).map((f:any)=>{
                        return{
                            name:f.name,
                            description:f.description,
                            RelativePath:f.RelativePath||"",
                            postCount:f.postCount,
                            slug:f.slug
                              }
                    }) || []
                    if(value)
                    return value
                 }
            }
            else
                return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    
    getAuthorsPagination=async(authorSlug:string,pageNo:number,countryCode:CountryCode)=>{
        try {
            const pageSize=10
            const result:any=await CmsAPI.get(`inco-cms/author?slug=${authorSlug}&pageno=${pageNo}&pagesize=${pageSize}&country=${countryCode.toUpperCase()}`);
            if(result && result.status==200) {   
                if(result.data){
                    const data = result.data
                     const value:any =  {
                     author_name:data.author_name,
                     author_description:data.author_description,
                     author_relative:data.author_relative,
                     postCount:data.postCount,
                     author_slug:data.author_slug,
                     paging_data:data.paging_data,
                     post:data.post && data.post.map((m:any)=>{
                        return {
                            post_id:m.post_id,
                            post_title:m.post_title,
                            post_content:m.post_content.slice(0,200),
                            post_relative:m.post_relative,
                            post_slug:m.post_slug,
                            post_published_date:m.post_published_date,
                            post_updated_date:m.post_updated_date,
                            sub_cat_name:m.sub_cat_name,
                            sub_cat_slug:m.sub_cat_slug,
                            parent_cat_name:m.parent_cat_name,
                            parent_cat_slug:m.parent_cat_slug
                        }
                    })}
               if (value) return value 
               else []
            }}
            else  return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    getJustInData=async(countryCode:CountryCode)=>{
        try {
            const keyName=RedisKey.JustInCMS;
            const redisResult=await RedisClient.getValue(keyName,countryCode);
            if(redisResult)
                return redisResult;
            const result=await CmsAPI.get(`/inco-cms/justIn?country=${countryCode.toUpperCase()}&parentCat=room`);
            if(result && result.status==200)        
            {
                const value=result.data && result.data.justin_post;
                if(value){
                    const data = value.map((f:any)=>{
                        return {
                            post_id:f.post_id,
                            post_title:f.post_title,
                            post_relative:f.post_relative,
                            post_slug:f.post_slug,
                            sub_cat_name:f.sub_cat_name,
                            sub_cat_slug:f.sub_cat_slug
                               }
                    }) || []
                    if(data)
                    RedisClient.setValue(keyName,data, countryCode); 
                    return data;
                }
                else return []
                   
            }
            else
                return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    GetInteriorFaqByCity = async (countryCode:CountryCode,CitySlug: any) => {
        try {
            const result = await CmsAPI.get(`inco-cms/interiorDesign?country=${getKeyByValue(CountryCode, countryCode)}&city=${CitySlug}`);
            if (result && result.status == 200)
                return result.data || [];
            else
                return [];
        } catch (error) {
            console.error(error);
            return [];
        }
    }


    GetHappyClientCity = async (countryCode?: CountryCode, CitySlug?: any) => {
        try {
            const result = await CmsAPI.get(`inco-cms/testimonial${CitySlug && countryCode ? `?country=${getKeyByValue(CountryCode, countryCode)}&city=${CitySlug}`:''}`);
            if (result && result.status == 200)
                return result.data || [];
            else
                return [];
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    
    designIdeaSeo=async(countryCode:CountryCode,categorySlug:string)=>{
        try {
            const keyName=RedisKey.DesignIdeaSeo;
            const redisResult=await RedisClient.getValue(keyName,countryCode,categorySlug);
            if(redisResult)
                return redisResult;
            const result=await CmsAPI.get(`inco-cms/design-ideas?country=${countryCode}&category=${categorySlug}`);
            if(result && result.status==200)        
            {
                const value=result.data && result.data;
                if(value && typeof value === 'object' && Object.keys(value).length > 0){
                RedisClient.setValue(keyName,value, countryCode,categorySlug); 
                return value;
                }else{
                    return {}
                }
            }
            else
                return {};   
        } catch (error) {
            console.error(error);
            return {};
        }
    }

    relatedCatPosts =async (categorySlug:string) => {
        try {
            const keyName=RedisKey.RelatedCatPosts;
            const redisResult=await RedisClient.getValue(keyName,CountryCode.INR,categorySlug);
            if(redisResult)
                return redisResult;

            const result=await CmsAPI.get(`inco-cms/relatedCategory?cat_slug=${categorySlug}`);
            if(result && result.status==200)        
            {
                const value=result.data || [];
                if(value){
                    const data = value && value.map((f:any)=>{
                        return {
                            cat_name:f.cat_name,
                            cat_slug:f.cat_slug,
                            posts:f.posts && f.posts.map((m:any)=>{
                                return {
                                    post_title:m.post_title,
                                    post_slug:m.post_slug,
                                    post_relative:m.post_relative
                                }
                            }) || [],
                        }
                    }) || []
                    if(data)
                    RedisClient.setValue(keyName,data,CountryCode.INR,categorySlug); 
                    return data;
                }
                else return []
                   
            }
            else
                return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    blogSearch = async (searchText:string) => {
        try {
            const result=await CmsAPI.get(`inco-cms/searchTitle?search=${searchText}`);
            if(result && result.status==200)       
            {
                const value=result.data || [];
                  return value               
            }
            else return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    getMarketingBanners=async (pageType:string) => {
        try {
            const result=await CmsAPI.get(`inco-cms/marketing-banner?page_type=${pageType}`);
            if(result && result.status==200)       
            {
                const value=result.data || [];
                  return value               
            }
            else return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    
    getMarketPlaceSeoContent = async (slug:string) => {
        try {
            const result=await CmsAPI.get(`inco-cms/market-place?slug=${slug}`);
            if(result && result.status==200)       
            {
                const value=result.data || [];
                  return value               
            }
            else return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    getBanners=async (pageName:string) => {
        try {
            const result=await CmsAPI.get(`inco-cms/banner?banner_page=${pageName}`);
            if(result && result.status==200)       
            {
                const value=result.data || [];
                  return value               
            }
            else return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    getMarketPlaceFilterMeta = async (catSlug:string,attr:string,) => {
        try {
            const result=await CmsAPI.get(`inco-cms/market-place-seo-meta?cat=${catSlug}&attr=${attr}`);
            if(result && result.status==200)       
            {
                const value=result.data || [];
                  return value               
            }
            else return [];   
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    getTimedPopUpData = async (slug:string) => {
        try {
            const result=await CmsAPI.get(`inco-cms/time_popup?url=${slug}`);
            if(result && result.status==200)       
            {
                const value=result.data || {};
                  return value               
            }
            else return {};   
        } catch (error) {
            console.error(error);
            return {};
        }
    }
}

export default new BlogService();